var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"advantages-section"},[_c('div',{staticClass:"app"},[_c(_setup.Advantages,{attrs:{"image":_setup.image,"infoBlocks":_setup.blocos}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }